"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitingRequestWrapper = void 0;
function getStatus(waitingReq) {
    if (["Submitted"].includes(waitingReq.status)) {
        return "Done";
    }
    if (["Expired", "Failed", "Withdrawn"].includes(waitingReq.status)) {
        return "Failed";
    }
    return "Pending";
}
function waitingRequestWrapper(waitingReq) {
    return {
        id: waitingReq.id,
        targetEventId: waitingReq.originEventId,
        fromNetworkId: waitingReq.originNetworkId,
        fromAddress: waitingReq.userTargetAddress,
        inputTokenContractId: waitingReq.inputTokenContractId,
        inputTokenAmount: waitingReq.inputTokenAmount,
        inputTokenAmountUSD: waitingReq.inputTokenAmountUSD,
        toNetworkId: "2",
        outputTokenContractId: waitingReq.outputTokenContractId,
        outputTokenAmount: waitingReq.outputTokenAmount,
        outputTokenAmountUSD: waitingReq.outputTokenAmountUSD,
        toAddress: waitingReq.userSourceAddress,
        networkFee: "0",
        lockerFee: "0",
        protocolFee: "0",
        thirdPartyFee: "0",
        bridgeFee: "0",
        totalFee: "0",
        tokenType: waitingReq.tokenType || "BTC",
        type: waitingReq.type,
        status: waitingReq.status,
        state: getStatus(waitingReq),
        createdAt: waitingReq.createdAt,
        updatedAt: waitingReq.updatedAt,
        fromNetwork: waitingReq.originNetwork,
        toNetwork: waitingReq.type.includes("Wrap")
            ? {
                id: "2",
                name: "bitcoin",
                title: "Bitcoin",
                lastBlock: "883407",
                chainId: 0,
                status: "Active",
                details: null,
            }
            : waitingReq.targetNetwork,
        targetEvent: waitingReq.originEvent,
        inputToken: waitingReq.inputToken,
        outputToken: waitingReq.outputToken,
        thirdPartyId: 0,
        sourceTransactionId: null,
        lockerId: null,
        crossChainId: null,
        sourceTransaction: null,
    };
}
exports.waitingRequestWrapper = waitingRequestWrapper;
//# sourceMappingURL=wrapper.js.map